import AddIcon from "@mui/icons-material/Add";
import { Fab, Grid, Menu, MenuItem, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_SITE_FILING_2 } from "../../constant/Apipath";
import ClientSiteFilingAddModel from "./clientSiteFilingAddModal/ClientSiteFilingAddModel";
import ClientSitefilingListing from "./component/ClientSitefilingListing";
import SiteFilePreview from "./component/previewModel/SiteFilePreview";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

function ClientSiteFilingFolderListing() {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;

  const data = useLocation();
  const folderData = data?.state;
  const { folderId } = useParams();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [sortMenu, setSortMenu] = useState(false);
  const [siteFilingData, setSiteFilingData] = useState([]);
  const [totoalItemCount, setTotalItemCount] = useState("");
  const [sortbyValue, setSortbyValue] = useState("dateCreated");
  const [showFilePreview, setShowFilePreview] = useState(false);
  const [showFilePreviewFile, setShowFilePreviewFile] = useState([]);

  const LANGUAGE = ClientEnglishFallback?.ClientSiteFilingFolder(
    multiLanguageData?.ClientSiteFilingFolder || {}
  );
  const { TEXT_TYPE, TEXT_NAME, TEXT_UPLOAD_DATE, TEXT_ITEMS, TEXT_SORT } = LANGUAGE;

  let SiteFileFolderArray = [
    { name: "fileType", value: TEXT_TYPE },
    { name: "name", value: TEXT_NAME },
    { name: "dateCreated", value: TEXT_UPLOAD_DATE }
  ];

  const [sortbyTransValue, setSortbyTransValue] = useState(TEXT_UPLOAD_DATE);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setSortMenu(() => true);
  };

  const handleClose = (value) => {
    setAnchorEl(null);
    setSortMenu(false);
    if (value) setSortbyValue(value);
    if (value)
      switch (value) {
        case "fileType":
          setSortbyTransValue(TEXT_TYPE);
          break;
        case "name":
          setSortbyTransValue(TEXT_NAME);
          break;
        case "dateCreated":
          setSortbyTransValue(TEXT_UPLOAD_DATE);
          break;
        default:
          break;
      }
  };

  useEffect(() => {
    if (folderId) fetchdata();
  }, [selectedClientData, folderId, sortbyValue, data?.state?.searchText]);

  const fetchdata = async () => {
    setLoading(true);
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: data?.state?.searchText || "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SortList: [{ FieldName: sortbyValue, Direction: "ASC" }],
        SearchList: [
          {
            folderId: folderId
          }
        ]
      };

      let res = await Postrequestcall(FETCH_CLIENT_SITE_FILING_2, obj, loginData?.accessToken);

      if (res?.status === 200) {
        let data1 = res?.data;
        setTotalItemCount(data1?.nrOfRecords);
        setSiteFilingData(data1?.data);
      }
    } catch (error) {
      console.error("fetchdata-> Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseFilePreview = () => {
    setShowFilePreview(false);
    setShowFilePreviewFile([]);
  };

  const SortMenu = () => (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={sortMenu}
      onClose={() => handleClose("")}
      defaultValue={sortbyValue}>
      {SiteFileFolderArray.map((menu, index) => {
        return (
          <MenuItem
            key={index}
            sx={{
              color: sortbyValue === menu.name ? selectedClientData?.AccentColor : ""
            }}
            onClick={() => handleClose(menu.name)}>
            {menu.value}
          </MenuItem>
        );
      })}
    </Menu>
  );

  return (
    <>
      {isLoading ? (
        <Loader fullScreen />
      ) : (
        <div>
          <Grid container size={12} rowGap={2} spacing={2}>
            <Grid size={12}>
              <Typography>{folderData?.name}</Typography>
              <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
                <Typography
                  sx={{
                    fontSize: "15px",
                    color: "grey"
                  }}>
                  {totoalItemCount} {TEXT_ITEMS}
                </Typography>
                <Stack display={"flex"} flexDirection={"row"} gap={1}>
                  <Typography
                    sx={{
                      fontSize: "15px",
                      color: "grey"
                    }}>
                    {TEXT_SORT}
                  </Typography>
                  <Typography
                    onClick={handleClick}
                    sx={{
                      cursor: "pointer",
                      fontSize: "15px",
                      color: selectedClientData?.AccentColor
                    }}>
                    {/* {sortbyValue == "dateCreated"
                      ? TEXT_UPLOAD_DATE
                      : sortbyValue == "fileType"
                        ? "Type"
                        : sortbyValue == "name"
                          ? "Name"
                          : ""} */}
                    {sortbyTransValue}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            {siteFilingData?.map((item, i) => (
              <Grid
                sx={{
                  border: "1px solid transparent",
                  cursor: "pointer",
                  padding: "10px",
                  "&:hover": {
                    border: "1px solid #e4e4e4",
                    borderRadius: "10px",
                    boxShadow: "0px 0px 10px 0px #e4e4e4",
                    transition: "0.3s"
                  }
                }}
                size={{
                  xs: 4,
                  sm: 4,
                  md: 2,
                  lg: 2,
                  xl: 1.5
                }}
                key={i}>
                <ClientSitefilingListing
                  item={item}
                  setShowFilePreviewFile={setShowFilePreviewFile}
                  setShowFilePreview={setShowFilePreview}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      )}
      <SortMenu />
      <Fab
        onClick={() => {
          setAddModal(true);
        }}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px"
        }}
        sx={{
          bgcolor: CLIENT_ACCENT_COLOR,
          "&:hover": {
            bgcolor: CLIENT_ACCENT_COLOR
          }
        }}
        aria-label="add">
        <AddIcon
          style={{
            color: "white"
          }}
        />
      </Fab>
      <ClientSiteFilingAddModel
        reloadData={() => {
          fetchdata();
        }}
        folderData={folderData}
        isOpen={addModal}
        onClose={() => setAddModal(false)}
      />
      {showFilePreview && (
        <SiteFilePreview
          open={showFilePreview}
          handleClose={handleCloseFilePreview}
          file={showFilePreviewFile}
        />
      )}
    </>
  );
}

export default ClientSiteFilingFolderListing;
